/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
// import { Stepper, Step } from "react-form-stepper";
import { Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import "swiper/css/parallax";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import { Row, Col, Carousel } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import PortfolioItem from "components/PortfolioItem";
import PageSection from "components/PageSection";
import Icon from "components/Icon";

import "./Timeline.scss";
import Step from "components/Step/Step";
import TimelineComponent from "components/Timeline/TimelineComponent";

import CardTimeline from "components/Card/CardTimeline";

const Timeline = ({ className, frontmatter }) => {
  const [index, setIndex] = useState(0);

  if (!frontmatter) {
    return null;
  }

  const {
    anchor,
    header: rootHeader,
    subheader: rootSubHeader,
    portfolios,
    timelines,
  } = frontmatter;

  return (
    <PageSection className={clsx("portfolio-section", "bg-soft-dark")} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        <Col>
          <TimelineComponent timelines={timelines} />
        </Col>
      </Row>
    </PageSection>
  );
};

Timeline.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Timeline.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Timeline;
